import { useCallback, useState } from 'react';
import { v4 } from 'uuid';

export const useIdempotencyKey = () => {
  const [key, setKey] = useState<string>(v4());

  const refreshKey = useCallback(() => {
    setKey(v4());
  }, []);

  return {
    key,
    refreshKey,
    setKey,
  };
};

export const IDEMPOTENCY_KEY_HEADER = 'Idempotency-Key';
